import * as Comp from './modal-body.styles'

type TModalBodyProps = {
  children: React.ReactNode
  testID?: string
}

export function ModalBody({ children, testID }: TModalBodyProps) {
  const componentProperties = {
    testID,
  }

  return <Comp.Body {...componentProperties}>{children}</Comp.Body>
}
